/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  PostUserRequestsIdSubmitPathParams,
  PostUserRequestsIdSubmit200,
  PostUserRequestsIdSubmit400,
  PostUserRequestsIdSubmitMutationResponse,
} from '../entities/PostUserRequestsIdSubmit'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { errorStructSchema } from './errorStructSchema'
import { z } from 'zod'

export const postUserRequestsIdSubmitPathParamsSchema = z.object({
  id: z.string().describe('ID заявки'),
}) as unknown as ToZod<PostUserRequestsIdSubmitPathParams>

/**
 * @description OK
 */
export const postUserRequestsIdSubmit200Schema = z.any() as unknown as ToZod<PostUserRequestsIdSubmit200>

/**
 * @description Bad Request
 */
export const postUserRequestsIdSubmit400Schema = z.lazy(() => errorStructSchema) as unknown as ToZod<PostUserRequestsIdSubmit400>

export const postUserRequestsIdSubmitMutationResponseSchema = z.lazy(
  () => postUserRequestsIdSubmit200Schema,
) as unknown as ToZod<PostUserRequestsIdSubmitMutationResponse>